import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import LoadingWrapper from '@ui/atoms/LoadingWrapper';

import useMemberInfo from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';

import { IFlowStepProps } from '@folx-types/flow-steps';

import StateRestrictionStep, {
	IStateRestrictionStepPageContent,
} from './StateRestrictionStep.component';

interface IStateRestrictionStepPageProps extends IFlowStepProps {}

const StateRestrictionStepPage: FC<IStateRestrictionStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "state-restriction-step" }) {
				state_restrictions {
					state_name
					page_header
					page_info
					learn_more_href
					show_learn_more
				}
				learn_more_text
			}
		}
	`);

	const { memberInfo, loading } = useMemberInfo();

	const refinedContent: IStateRestrictionStepPageContent = keysToCamel(
		pageContent
	) as IStateRestrictionStepPageContent;

	return (
		<LoadingWrapper loading={loading}>
			<StateRestrictionStep
				pageContent={refinedContent}
				path={path}
				stepKey={stepKey}
				memberInfo={memberInfo}
			/>
		</LoadingWrapper>
	);
};

export default StateRestrictionStepPage;
